export default __webpack_public_path__ + "e37a85c9448419a5d7c48d9c9bd2c65f.png";